import { Translation } from '@ps/web-shared-components';

import HyperTurboIcon from '../../../assets/icons/speed/hyper-turbo.svg';
import RegularIcon from '../../../assets/icons/speed/regular.svg';
import SlowIcon from '../../../assets/icons/speed/slow.svg';
import TurboIcon from '../../../assets/icons/speed/turbo.svg';
import type { IconsLegendData } from '../IconGroupLegend';
import IconGroupLegend from '../IconGroupLegend';

import {
  TXTCLI_Game_Speed,
  TXTCLI_Hyper_Turbo,
  TXTCLI_Regular,
  TXTCLI_Slow,
  TXTCLI_Turbo
} from './GameSpeedIconLegend.messages.json';

const gameSpeedConfig: IconsLegendData[] = [
  {
    Icon: <SlowIcon />,
    Description: <Translation tagName="span" {...TXTCLI_Slow} />
  },
  {
    Icon: <RegularIcon />,
    Description: <Translation tagName="span" {...TXTCLI_Regular} />
  },
  {
    Icon: <TurboIcon />,
    Description: <Translation tagName="span" {...TXTCLI_Turbo} />
  },
  {
    Icon: <HyperTurboIcon />,
    Description: <Translation tagName="span" {...TXTCLI_Hyper_Turbo} />
  }
];

const GameSpeedIconLegend: React.FC = () => (
  <IconGroupLegend data={gameSpeedConfig} title={<Translation {...TXTCLI_Game_Speed} />} />
);

export default GameSpeedIconLegend;
